export const filterHasItemsForMultiSelect = (options: any, fieldInItem: string[]) => {
    if (options === '' || options === undefined || options.length === 0) {
        return true;
    }
    const hasItems = fieldInItem.length > 0;
    return options.includes(hasItems);
};
